import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/favorite-match-1.png'
import _imports_1 from '@/assets/images/favorite-shape.png'
import _imports_2 from '@/assets/images/favorite-match-2.png'
import _imports_3 from '@/assets/images/favorite-shape-2.png'
import _imports_4 from '@/assets/images/shape-8.png'


const _hoisted_1 = { class: "favorite-match-area bg-gondola3 position-relative z-1 bg-50" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 col-md-6" }
const _hoisted_5 = {
  class: "favorite-match-single-item position-relative z-1 mb-4 mb-md-0 overflow-hidden hover-style1",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_6 = { class: "hover-style2" }
const _hoisted_7 = { class: "col-lg-6 col-md-6" }
const _hoisted_8 = {
  class: "favorite-match-single-item position-relative z-1 overflow-hidden hover-style1",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_9 = { class: "hover-style2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("h2", null, "لا تفوت مبارياتك الرياضية المفضلة", -1)),
              _createVNode(_component_RouterLink, {
                to: "/pricing-plan",
                class: "btn"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "border-style" }, "استعرض جميع الدوريات الرياضية", -1)
                ]))]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "favorite-match-img" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "favorite-match"
                })
              ], -1)),
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: _imports_1,
                class: "favorite-shape",
                alt: "favorite-shape"
              }, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "favorite-match-img-2" }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: "favorite-match"
                })
              ], -1)),
              _cache[6] || (_cache[6] = _createElementVNode("h2", null, "ابقَ على اطلاع بأحدث الأخبار العالمية", -1)),
              _createVNode(_component_RouterLink, {
                to: "/pricing-plan",
                class: "btn"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "border-style" }, "استعرض جميع القنوات الإخبارية", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("img", {
                src: _imports_3,
                class: "favorite-shape",
                alt: "favorite-shape"
              }, null, -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("img", {
      src: _imports_4,
      class: "shape shape-8",
      alt: "shape"
    }, null, -1))
  ]))
}